<template>
  <div>
    <NavBar title="优惠劵">
         <!-- 可以通过slot插入右侧按钮内容 -->
         <template v-slot:right-button>
           <!-- <button >菜单</button> -->
           <img class="closeImg" @click="closePage" src="../assets/close.png"/>
         </template>
       </NavBar>
    <div class="coupon-page">

      <div class="coupon" @click="openGoods">
        <div class="coupon_yuan">
          <span class="yuan">{{coupon}}</span><span>元</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  date(){
    return{
      coupon:null,
      queryData:null
    }
  },
  created(options){
    this.coupon = this.$route.query.coupon
    this.queryData = this.$route.query
  },
  methods: {
    closePage(){

    },
    openGoods(){
      this.$router.push({
        name: 'ceshi',
        query: this.queryData
      })
    },
    redeemCoupon() {
      alert('Coupon redeemed!');
    }
  }
}
</script>

<style scoped>
.coupon-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #000;
  color: #fff;
}

.coupon {
  background-image: url('../assets/couponbg.png');
  background-size: 100% 100%;
  width: 300px;
  height: 300px;
  color: #000;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.coupon h1 {
  margin: 0;
  font-size: 2.5em;
}

.coupon p {
  margin: 10px 0;
  font-size: 1.2em;
}

.coupon button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
}

.coupon button:hover {
  background-color: #0056b3;
}
.coupon_yuan{
  margin-top: 54%;
  font-weight: bold;
  color: #fff;
}
.yuan{
  font-size: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/coupon.vue